import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FraudAlertCard = ({ alert, onInvestigate, onDismiss }) => {
  const getSeverityColor = () => {
    switch (alert?.severity) {
      case 'critical': return 'border-error bg-error/5';
      case 'high': return 'border-warning bg-warning/5';
      case 'medium': return 'border-accent bg-accent/5';
      default: return 'border-border bg-muted/30';
    }
  };

  const getSeverityIcon = () => {
    switch (alert?.severity) {
      case 'critical': return 'AlertTriangle';
      case 'high': return 'AlertCircle';
      case 'medium': return 'Info';
      default: return 'Bell';
    }
  };

  const getSeverityIconColor = () => {
    switch (alert?.severity) {
      case 'critical': return 'text-error';
      case 'high': return 'text-warning';
      case 'medium': return 'text-accent';
      default: return 'text-muted-foreground';
    }
  };

  return (
    <div className={`rounded-xl p-4 md:p-5 border-2 ${getSeverityColor()} transition-smooth hover:shadow-elevation-2`}>
      <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4">
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg bg-background flex items-center justify-center flex-shrink-0`}>
          <Icon name={getSeverityIcon()} size={20} className={getSeverityIconColor()} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h3 className="text-sm md:text-base font-semibold text-foreground">{alert?.title}</h3>
            <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getSeverityIconColor()} bg-background`}>
              {alert?.severity?.toUpperCase()}
            </span>
          </div>
          <p className="text-xs md:text-sm text-muted-foreground mb-3">{alert?.description}</p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3 mb-3 md:mb-4">
            <div className="flex items-center gap-2">
              <Icon name="User" size={14} className="text-muted-foreground" />
              <span className="text-xs md:text-sm text-foreground">{alert?.userId}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={14} className="text-muted-foreground" />
              <span className="text-xs md:text-sm text-foreground">{alert?.timestamp}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={14} className="text-muted-foreground" />
              <span className="text-xs md:text-sm text-foreground">{alert?.location}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="TrendingUp" size={14} className="text-muted-foreground" />
              <span className="text-xs md:text-sm text-foreground">Risk: {alert?.riskScore}%</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
        <Button
          variant="default"
          size="sm"
          iconName="Search"
          iconPosition="left"
          onClick={() => onInvestigate(alert?.id)}
          className="flex-1"
        >
          Investigate
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="X"
          iconPosition="left"
          onClick={() => onDismiss(alert?.id)}
          className="flex-1"
        >
          Dismiss
        </Button>
      </div>
    </div>
  );
};

export default FraudAlertCard;